import { GetPipelineStageProjectsInput } from '@/gql/graphql';
import { minutesToMilliseconds } from 'date-fns';

export const PIPELINE_SCROLL_POSITION_MAX_AGE_MS = minutesToMilliseconds(10);

export const getPipelineScrollPositionKey = (pipelinePublicId: string) =>
  `pipeline:${pipelinePublicId}`;

export const getPipelineStageScrollPositionKey = (
  pipelinePublicId: string,
  pipelineStagePublicId: string,
  input: GetPipelineStageProjectsInput | undefined
) =>
  `pipeline:${pipelinePublicId}:stage:${pipelineStagePublicId}:${JSON.stringify(input ?? {})}`;
